export * from './personas-detail.model';
export * from './persona.model';
